import {
  COPILOT_WINDOW_MODE_KEY,
  TCopilotWindowMode,
} from '@/pages/aigc/pages/Agent/config/constant';

const DEFAULT_WINDOW_MODE: TCopilotWindowMode = 'floating';

const isValidWindowMode = (value: string | null): value is TCopilotWindowMode =>
  value === 'floating' || value === 'docked';

/** 读取 Copilot 默认窗口模式（localStorage） */
export const getCopilotDefaultWindowMode = (): TCopilotWindowMode => {
  try {
    const value = localStorage.getItem(COPILOT_WINDOW_MODE_KEY);
    return isValidWindowMode(value) ? value : DEFAULT_WINDOW_MODE;
  } catch {
    return DEFAULT_WINDOW_MODE;
  }
};

/** 写入 Copilot 默认窗口模式（localStorage） */
export const setCopilotDefaultWindowMode = (mode: TCopilotWindowMode): void => {
  try {
    localStorage.setItem(COPILOT_WINDOW_MODE_KEY, mode);
  } catch {
    // localStorage 不可用时忽略
  }
};
